export const stringOrEmpty = (value: string | undefined): string => value ?? '';
